<div *ngIf="existingbookingOB" class="searchdiv">
  <div class="card screen-wrapper">
    <app-shared-header-div [screentitle] ="screentitle" [Errmessage]="Errmessage" [headerDivName]="headerDivName"></app-shared-header-div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div class ="sub-m-portlet">
                  <div>
                    <div>
                      <app-shared-instruct-div></app-shared-instruct-div>

                      <div class="col-md-3">
                        <label>INTERMILES Number </label>
                        <input [(ngModel)]="search_details.jp_number" maxlength="11" (keypress)="keypresshandler($event)"
                          type="text" (input)="isEmpty()" class="form-control m-input"
                          placeholder="{{inputPlaceholder.intermilesNumber}}" (keyup)="jpNumberValidation();" />
                        <span id="JpErr" style="color: red;font-size: 10px"></span>
                      </div>


                      <div class="col-md-3">
                        <label class="">Airline PNR</label>
                        <input [(ngModel)]="search_details.airlinepnr" type="text" class="form-control m-input"
                          placeholder="{{inputPlaceholder.airlinePnr}}" (input)="isEmpty()" (keyup)="pnrValidation();"
                          style="text-transform: uppercase" maxlength="6" />
                        <span id="pnrNO"></span>
                      </div>

                      <div class="col-md-3">
                        <label class="">Booking Reference No</label>
                        <input [(ngModel)]="search_details.order_id" type="text" class="form-control m-input"
                          maxlength="18" placeholder="{{inputPlaceholder.bookingReferenceNumber}}" (keyup)="orderValidation();"
                          (blur)="orderValidation1()" (input)="isEmpty()" style="text-transform: uppercase" />
                        <span id="orErr"></span>
                      </div>


                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3">
                        <label class="">Ticket No </label>
                        <input [(ngModel)]="search_details.Ticket_No" type="text" class="form-control m-input"
                          placeholder="{{inputPlaceholder.ticketNumber}}" maxlength="15" (input)="isEmpty()" />
                        <span id="orErr"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">First Name</label>

                        <input [(ngModel)]="search_details.first_name" type="text" class="form-control m-input"
                          placeholder="{{inputPlaceholder.firstName}}" (input)="isEmpty()" (keyup)="fnameValidation();" />
                        <span id="fnErr" style="color: red;font-size: 10px"></span>
                      </div>
                      <div class="col-md-3">
                        <label class="">Last Name</label>
                        <input [(ngModel)]="search_details.last_name" type="text" class="form-control m-input"
                          placeholder="{{inputPlaceholder.lastName}}" (input)="isEmpty()" (keyup)="lnameValidation();" />
                        <span id="lnErr" style="color: red;font-size: 10px"></span>
                      </div>


                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>

                      <div class="col-md-3">
                        <label class="">Booking Status</label>
                        <select [disabled]="isUniqueFilter"
                        class="form-control m-input" 
                        (change)="isEmpty()"
                         [(ngModel)]="search_details.status">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option 
                          *ngFor="let item of booking_status" 
                          value="{{ item.key }}">{{ item.value }}</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="">Ancillary Type</label>
                        <select [disabled]="isUniqueFilter" 
                        class="form-control m-input" 
                        (change)="isEmpty()"
                          [(ngModel)]="search_details.ancillary_type">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option 
                          *ngFor="let item of ancillary_type_map" 
                          value="{{ item.key }}">{{ item.value }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="">Ancillary Status</label>
                        <select [disabled]="isUniqueFilter"
                        class="form-control m-input" 
                        (change)="isEmpty()"
                          [(ngModel)]="search_details.ancillary_status">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option 
                          *ngFor="let item of ancillary_bkg_status_map" 
                          value="{{ item.key }}">{{ item.value }}
                          </option>
                        </select>
                      </div>

                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>

                      <div class="col-md-3">
                        <label class="">Affiliate Partner</label>
                        <select [disabled]="!isAccrual || isUniqueFilter" class="form-control m-input" (change)="isEmpty()"
                          [(ngModel)]="search_details.aff_partner">
                          <option value="E" disabled>Select</option>
                          <option value="">All</option>

                          <option *ngFor="let item of orderBooking_aff_partner" value="{{ item.key }}">{{ item.value }}
                          </option>
                        </select>
                      </div>

                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input id="did" #input3 matInput [(ngModel)]="search_details.bookingdate_from"
                            [matDatepicker]="pickerFrom1" (dateChange)="toggleDisable2();incresedate();isEmpty();"
                            [disabled]="bookingdate" autocomplete="off" placeholder="{{inputPlaceholder.bookingDateFrom}}" readonly
                            [max]="myDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerFrom1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerFrom1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset3(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                      </div>

                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input [min]="final" #input4 matInput [disabled]="bookingdate"
                            [(ngModel)]="search_details.bookingdate_to" [matDatepicker]="pickerTO"
                            (dateChange)="isEmpty();" autocomplete="off" placeholder="{{inputPlaceholder.bookingDateTo}}" readonly
                            [max]="newDate" />
                          <mat-datepicker-toggle matSuffix [for]="pickerTO"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTO></mat-datepicker>
                        </mat-form-field>
                        <button type="button" class="close opa" (click)="reset4(); checkStatus1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <br />
                        <span *ngIf="invaliddate" style="color: red;font-size: 10px">
                          'To' date should be greater than 'From' date
                        </span>
                      </div>

                      <div class="clr"></div>
                      <div class="divider" style="height:0px !important"></div>
                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input #input2 matInput [(ngModel)]="search_details.tripdate_From" id="deptfrom"
                            [disabled]="journeydate" [matDatepicker]="pickerTo1"
                            (dateChange)="toggleDisable1();setDepartureTo();isEmpty()" autocomplete="off"
                            placeholder="{{inputPlaceholder.departureFrom}}" readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerTo1"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTo1></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset2();toggleDisable1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>

                        </button>
                      </div>

                      <div class="col-md-3" style="margin-top: 19px">
                        <mat-form-field>
                          <input [min]="set_dept_to" #input9 matInput [(ngModel)]="search_details.tripdate_to"
                            [disabled]="journeydate" [matDatepicker]="pickerTo3"
                            (dateChange)="toggleDisable1();isEmpty()" autocomplete="off" placeholder="{{inputPlaceholder.departureTo}}"
                            readonly />
                          <mat-datepicker-toggle matSuffix [for]="pickerTo3"></mat-datepicker-toggle>
                          <mat-datepicker #pickerTo3></mat-datepicker>
                        </mat-form-field>

                        <button type="button" class="close opa" (click)="reset();toggleDisable1()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>

                        </button>
                      </div>

                    </div>

                  </div>
                </div>
              </div>
              <div class="clr"></div>

              <div class="clr">

              </div>

              <div class="col-md-12" style="padding: 2% 1% 2% 2%">

                <div class="col-md-6">
                  <ng-container *ngIf="typeOfRedemption == 'A' && buttonFlag == true">
                    <button type="button" class=" btn btn-info" [disabled]="IsSpace ==  true "
                      (click)="TBOmethod()">Generate Booking ID</button>
                    <div id="success_sms" style="color: #676a6c;font-size: 16px;margin-top: 10px;font-weight: bold;"
                      *ngIf="TBO_sms == true ">{{SMS}}</div>
                  </ng-container>
                </div>
                <div class="col-md-6">

                  <div class="sdiv">
                    <div class="btn clear-button button-margin">
                      <button class="btn btn-primary  commonbutt" [disabled]="IsEmptyVal == false || IsErr == true"
                        (click)="searchData()" type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <div class="sdiv" style="margin-top: -11px;">
                    <label class=""> EMail Status</label>
                    <select class="form-control m-input"
                      style="height: 27px !important;padding: 0px 10px;margin-top: 5px;" (change)="isEmpty()"
                      [(ngModel)]="search_details.isMailSent">
                      <option value="">All</option>
                      <option value="1">Sent</option>
                      <option value="0">Not Sent</option>
                    </select>
                  </div>
                  <div class="sdiv" style="margin-top: 20px;margin-right: 10px;">
                    <label class=""> Accrual</label>
                    <input type="radio" value="A" name="type" checked (click)="selectTypeOfRedemption('A')">
                    <label class=""> Redemption</label>
                    <input type="radio" value="R" name="type"  (click)="selectTypeOfRedemption('R')">
                  </div>


                </div>
              </div>

              <div class="errwrap">
                <div class="errdiv1" id="err"></div>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list != '' || search_detail_list != 0"
                [hidden]="searchlist">
                <table aria-describedby="orderBookingData" class="table table-striped" *ngIf="!loader" [mfData]="serachtabledata" [mfRowsOnPage]="6">
                  <thead>
                    <tr>
                      <th scope="col">Booking Reference No</th>
                      <th scope="col" *ngIf="typeOfRedem == 'A'">Parent Reference No</th>
                      <th scope="col">INTERMILES Number</th>
                      <th scope="col">Passenger Name</th>
                      <th scope="col">Sector</th>
                      <th scope="col">PNR</th>
                      <th scope="col">Booking Date</th>
                      <th scope="col">Ticket No</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="link" *ngFor="
                        let item of (search_detail_list
                          | paginate: { itemsPerPage: 10, currentPage: p ,totalItems:totalItems })
                      " (click)="book_details(item.Booking_Ref)">
                      <td *ngIf="item.STATUS_NAME != 'Booked'">
                        <!-- JPUB{{ item.Booking_Ref }} new_order_changes-->
                        {{item.Booking_Ref.length == 18 ? '' : 'JPUB'}}{{item.Booking_Ref}}
                      </td>
                      <td *ngIf="item.STATUS_NAME == 'Booked'">
                        <!-- JPUB{{ item.Booking_Ref }} new_order_changes-->
                        {{item.Booking_Ref.length == 18 ? '' : 'JPUB'}}{{item.Booking_Ref}}
                      </td>
                      <td *ngIf="typeOfRedem == 'A'">
                        <!-- JPUB{{ item.Booking_Ref }} new_order_changes-->
                        {{item.Parent_Booking_Ref != null ? item.Parent_Booking_Ref : 'NA'}}
                      </td>
                      <ng-container *ngIf="typeOfRedem == 'A'">
                        <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                          NA
                        </td>
                        <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                          {{ item.JP_NUMBER }}
                        </td>
                      </ng-container>
                      <ng-container *ngIf="typeOfRedem == 'R'">
                        <td *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                          NA
                        </td>
                        <td *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                          {{ item.JP_NUMBER.slice(2, 11) }}
                        </td>
                      </ng-container>
                      <td>{{item.Lead_Pax}}</td>
                      <td>{{item.service_name}}</td>
                      <td *ngIf="item.AIRLINE_PNR == undefind || item.AIRLINE_PNR == null || item.AIRLINE_PNR == ''">NA
                      </td>
                      <td *ngIf="item.AIRLINE_PNR != undefind && item.AIRLINE_PNR != null && item.AIRLINE_PNR != '' ">{{
                        item.AIRLINE_PNR}}
                      </td>

                      <td *ngIf="item.STATUS_NAME != 'Booked'">
                        {{ item.BOOKING_DATE | date: "dd-MM-yyyy HH:mm:ss" }}
                      </td>
                      <td *ngIf="item.STATUS_NAME == 'Booked'">
                        {{ item.BOOKING_DATE | date: "dd-MM-yyyy HH:mm:ss" }}
                      </td>

                      <td *ngIf="item.Ticket_No == undefind || item.Ticket_No == null || item.Ticket_No == ''">NA</td>
                      <td *ngIf="item.Ticket_No != undefind && item.Ticket_No != null && item.Ticket_No != '' ">
                        {{ item.Ticket_No}}</td>

                      <td *ngIf="item.STATUS_NAME != 'Booked'">
                        {{ item.STATUS_NAME }}
                      </td>
                      <td *ngIf="item.STATUS_NAME == 'Booked'">
                        {{ item.STATUS_NAME }}
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="8">
                        <pagination-controls (pageChange)="pageCount($event)" total-items="totalItems">
                        </pagination-controls>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div style="padding: 2% 4% 2% 2%" *ngIf="search_detail_list == '' || search_detail_list == 0">
                <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                  {{ noresult }}
                </h1>
              </div>
              <div *ngIf="loader">
                <div style="margin: 0 auto; text-align: center;">
                  <img src="../../../../assets/img/Loading_Animation.gif" width="8%" height="8%" alt="Loader">

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>